import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { setCalendarPmsId } from "../../../features/pmsSlice";

function CalendarTooltip(props) {
  const { maintenanceName, dueStatus, id, type, handleData } = props;
  const dispatch = useDispatch();
  const normalizedDueStatus = String(dueStatus ?? "").toUpperCase();
  const setScreenData = () => {
    switch (type) {
      case "OTHER":
        handleData();
        break;
      default:
        dispatch(setCalendarPmsId(id));
    }
  };
  return (
    <>
      <OverlayTrigger
        placement="right"
        delay={{ show: 250, hide: 400 }}
        overlay={<Tooltip>{maintenanceName}</Tooltip>}
      >
        <div
          className={
            normalizedDueStatus === "DUE"
              ? "due"
              : normalizedDueStatus === "OVERDUE"
                ? "overdue"
                : normalizedDueStatus === "WARNING"
                  ? "warning"
                  : normalizedDueStatus === "IN PROGRESS" && "inprogress"
          }
          role="presentation"
          onClick={() => setScreenData()}
        >
          {maintenanceName}
        </div>
      </OverlayTrigger>
    </>
  );
}

export default CalendarTooltip;
